export default "__VITE_ASSET__DOGbQAsD__"